// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header {
  background-color: #0e1b1b;
  width: 100%;
  color: white;
  border-bottom: 1.5px solid rgba(255, 255, 255, 0.05);
  height: 12vh;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
}
.HeaderContainer {
  padding-left: 4vw;
  padding-top: 3vh;
  padding-bottom: 3vh;
  display: flex;
  align-items: center;
  gap: 7vw;
  position: relative;
  width: 100%;
}
.amalgamateHeaderLogo {
  height: 54px;
  width: 207.17px;
  cursor: pointer;
}
.HeaderHeading {
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: -0.4px;
  white-space: nowrap;
}
.headerRightActions {
  position: absolute;
  right: 5%;
  display: flex;
  align-items: center;
  gap: 24px;
}

.headerProfileIconWrapper{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.headerProfileIconWrapper .profileImage {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  border: 1.5px solid rgba(90, 175, 154, 0.3);
  transition: transform 0.2s ease;
}

.headerProfileIconWrapper .profileImage:hover {
  transform: scale(1.05);
}

.profileMenu {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}

.profileMenuItem {
  background-color: #071414;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 90px;
  height: 32px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
  transition: all 0.2s ease;
  cursor: pointer;
}

.profileMenuItem:hover {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(90, 175, 154, 0.5);
}

.profileMenuItemText {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.3px;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease;
}

.profileMenuItemText:hover {
  color: #00e0c5;
}

@media (max-width: 1640px) {
  .amalgamateHeaderLogo {
    height: 48px;
    width: 190px;
  }
  .HeaderHeading {
    font-size: 28px;
  }
}

@media (max-width: 1440px) {
  .amalgamateHeaderLogo {
    height: 40px;
    width: 170px;
  }
  .HeaderHeading {
    font-size: 26px;
  }
}

@media (max-width: 1280px) {
  .amalgamateHeaderLogo {
    height: 36px;
    width: 150px;
  }
  .HeaderHeading {
    font-size: 24px;
  }
}

@media (max-width: 1024px) {
  .amalgamateHeaderLogo {
    height: 32px;
    width: 130px;
  }
  .HeaderHeading {
    font-size: 22px;
  }
} 

.back-to-hub-btn {
  background: transparent;
  border: 1px solid rgba(0, 229, 200, 0.55);
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #00e5c8;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.back-to-hub-btn:hover {
  background: rgba(0, 229, 200, 0.1);
  border-color: #00e5c8;
  color: #33edd5;
}

`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;AACT;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.Header {\n  background-color: #0e1b1b;\n  width: 100%;\n  color: white;\n  border-bottom: 1.5px solid rgba(255, 255, 255, 0.05);\n  height: 12vh;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n}\n.HeaderContainer {\n  padding-left: 4vw;\n  padding-top: 3vh;\n  padding-bottom: 3vh;\n  display: flex;\n  align-items: center;\n  gap: 7vw;\n  position: relative;\n  width: 100%;\n}\n.amalgamateHeaderLogo {\n  height: 54px;\n  width: 207.17px;\n  cursor: pointer;\n}\n.HeaderHeading {\n  text-align: center;\n  font-family: \"Inter\", sans-serif;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 25px;\n  letter-spacing: -0.4px;\n  white-space: nowrap;\n}\n.headerRightActions {\n  position: absolute;\n  right: 5%;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.headerProfileIconWrapper{\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.headerProfileIconWrapper .profileImage {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1.5px solid rgba(90, 175, 154, 0.3);\n  transition: transform 0.2s ease;\n}\n\n.headerProfileIconWrapper .profileImage:hover {\n  transform: scale(1.05);\n}\n\n.profileMenu {\n  position: absolute;\n  top: calc(100% + 12px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n}\n\n.profileMenuItem {\n  background-color: #071414;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  min-width: 90px;\n  height: 32px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.profileMenuItem:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-color: rgba(90, 175, 154, 0.5);\n}\n\n.profileMenuItemText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.profileMenuItemText:hover {\n  color: #00e0c5;\n}\n\n@media (max-width: 1640px) {\n  .amalgamateHeaderLogo {\n    height: 48px;\n    width: 190px;\n  }\n  .HeaderHeading {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .amalgamateHeaderLogo {\n    height: 40px;\n    width: 170px;\n  }\n  .HeaderHeading {\n    font-size: 26px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .amalgamateHeaderLogo {\n    height: 36px;\n    width: 150px;\n  }\n  .HeaderHeading {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .amalgamateHeaderLogo {\n    height: 32px;\n    width: 130px;\n  }\n  .HeaderHeading {\n    font-size: 22px;\n  }\n} \n\n.back-to-hub-btn {\n  background: transparent;\n  border: 1px solid rgba(0, 229, 200, 0.55);\n  border-radius: 20px;\n  padding: 6px 14px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: #00e5c8;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.back-to-hub-btn:hover {\n  background: rgba(0, 229, 200, 0.1);\n  border-color: #00e5c8;\n  color: #33edd5;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
